import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { deleteUser } from "../api";

export const useDeleteUser = () => {
  const router = useNavigate();
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: deleteUser,
    onSuccess() {
      queryClient.refetchQueries({ queryKey: ["USER"] });
      router("/user");
      toast.success("Success Delete User");
    },
  });

  return { Delete: mutate, isPending };
};
